export type ConditionErrorMessage = {
  /**
   * Is the message internal or provided by the game author?
   */
  internal: boolean

  message: string
}
